import cf from './cf';
import i1zv2_20211024 from './i1zv2_20211024';

export default class i1zv2a extends i1zv2_20211024 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      name: '予約の確認、キャンセル・新規予約',
      class: 'i1zv2a',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  } 

}
